import DefaultButtonDark from "@/components/Buttons/DefaultButtonDark/DefaultButtonDark";
import { ILink } from "@/src/types";
import React, { useState } from "react";
import S from "./PriceCard.styled";
import CheckIcon from '@/src/images/CheckIcon.png';
export interface Props {
  title: string;
  text: string;
  language?: string;
  priceCard: {
    title: string;
    text: string;
    price: string;
    bindingPeriod: string;
    button: ILink;
    specifications: Specifications;
  }[];
}

export type Specifications = Array<{
  specification: string;
}>

const extractUniqueSpecifications = (specifications: Specifications[]): string[] => {
  const allSpecifications = specifications.flatMap(o => o.map(o => o.specification));

  return Array.from(new Set(allSpecifications));
}

const SPECIAL_FIELDS: ReadonlyArray<string> = [
  "price",
  "bindingPeriod",
  "text"
]

const PriceCard = ({ priceCard, language }: Props) => {
  let order: string[] = [];

  if (language === 'sv') {
    order = ["price", "text", "Nedladdningsbart innehåll.Utvalda", "Rapporter", "Presentationer", "Best practice", "Software reviews", "Taktiska nyckeltal.Läsa", "Radar Insights.Nyhetsbrev", "Håll dig uppdaterad.Intervjuer", "Branschsvep", "Spaningar", "Jämför.Benchmarks", "Konsultpriser", "Leverantörer", "Event.Fysiska", "Ondemand", "Talks", "Tvods", "Inbjudan till seminarium för IT/Tech leverantörer", "Datautbyte.i Insiktshub", "Scorecards", "Skräddarsytt", "Support.Hjälp", "Analytiker och Rådgivare.Chatt", "Direktkontakt", "Presentationer/Talare.Internt (till ex ledning)", "För extern publik", "Workshops.Mål- och resultatdrivna", "Utvärdering.Avtal", "Strategi", "Effekt av IT-investering", "Nöjdhet", "Partnerskap.Governance", "Flerårsstrategi"];
  } else if (language === 'en') {
    order = ["price", "text", "Downloadable content.Featured", "Reports", "Presentations", "Best practice", "Software reviews", "Tactical keyfigures.Read", "Radar Insights.Newsletter", "Stay updated.Interviews", "Industry sweep", "Scouting", "Compare.Benchmarks", "Consulting prices", "Vendors", "Event.Physical", "Ondemand", "Talks", "Tvods", "Invitation to seminars for IT/Tech vendors", "Data exchange.in Insight hub", "Scorecards", "Tailor made", "Support.Help", "Analysts and Advisors.Chat", "Direct contact", "Presentations/Speakers.Internal (eg management)", "For external audiences", "Workshops.Goal- and resultdriven", "Evaluation.Agreement", "Strategy", "Effect of IT investment", "Satisfaction", "Partnership.Governance", "Multi-year strategy"];
  }

  const [expandAccordion, setExpandAccordion] = useState(false);
  let uniqueSpecifications = extractUniqueSpecifications(priceCard.map(o => o.specifications)).filter(o => o.replace(/\*.*/, '') === o);
  uniqueSpecifications.unshift('price', 'text');
  uniqueSpecifications.sort((a, b) => order.indexOf(a) - order.indexOf(b));
  const memberships = priceCard.map(o => o.title);

  const footnotes = [...new Set(extractUniqueSpecifications(priceCard.map(o => o.specifications)).map(spec => /\*/.test(spec) ? spec.split('*')[1] : '').sort())];
  if (language === 'sv') {
    footnotes.push('7) Tjänster tillgängliga separat.');
  } else if (language === 'en') {
    footnotes.push('7) Services available seperately.');
  }

  return (
    <S.TableWrapper>
      <S.Table>
        <thead>
          <S.Tr>
            <S.Th></S.Th>
            <S.Th></S.Th>
            {priceCard.map(item => <S.Th>{item.title}</S.Th>)}
          </S.Tr>
        </thead>
        <tbody>
          {uniqueSpecifications.map((item, index) => {
            const hideIndex = Math.round(uniqueSpecifications.length / 2);
            return (
              <S.Tr key={item}>
                {/\w+\.\w+/.test(item) ? <S.Td hide={index > hideIndex && !expandAccordion}>{item.split('.')[0]}</S.Td> : <S.Td hide={index > hideIndex && !expandAccordion}></S.Td>}
                {/\w+\.\w+/.test(item) ? <S.Td hide={index > hideIndex && !expandAccordion}>{item.split('.')[1].replace(/\*.*/, '')}</S.Td> : <S.Td hide={index > hideIndex && !expandAccordion}>{item.replace(/price|text|\*.*/g, '')}</S.Td>}
                {memberships.map(m => {
                  const membership = priceCard.find(pc => pc.title === m);
                  const membershipSpecs = membership?.specifications.flatMap(o => o.specification) ?? [];

                  if (item === "title") {
                    return null;
                  }

                  if (SPECIAL_FIELDS.includes(item)) {
                    return <S.Td>{membership?.[item]}</S.Td>
                  }
                  else {
                    const footnote = membershipSpecs.filter(spec => spec.replace(/\*.*/, '') === item);
                    const isChecked = membershipSpecs.some(spec => spec.replace(/\*.*/, '') === item);
                    const text = membershipSpecs.includes(item) || isChecked ?
                      <S.OptionContainer><img src={CheckIcon} /><S.SmallParagraph>{footnote.length > 0 && /\*/.test(footnote[0]) ?
                        footnote[0].split('*')[1].replace(/\W.*/, '') : ''}{footnote.length > 0 && /\*/.test(footnote[0]) && footnote[0].split('*')[2] ? ',' + footnote[0].split('*')[2].replace(/\W.*/, '') : ''}</S.SmallParagraph></S.OptionContainer> :
                      <S.OptionContainer><S.Dash>-</S.Dash><S.SmallParagraph dash={true}>{(index > 25 && index < 32) ? '7' : ''}</S.SmallParagraph></S.OptionContainer>;

                    return <S.Td hide={index > hideIndex && !expandAccordion}>{text}</S.Td>
                  }
                })}
              </S.Tr>
            )
          })}
          <S.Tr>
            <S.Td></S.Td>
            <S.Td></S.Td>
            <S.Td colSpan={4}>
              <S.TableButton onClick={() => setExpandAccordion(!expandAccordion)} title="toggle-accordion">
                <div>{expandAccordion ? 'Hide' : '⇣ Show More Details ⇣'}</div>
              </S.TableButton>
            </S.Td>
          </S.Tr>
          <S.Tr>
            <S.Td></S.Td>
            <S.Td></S.Td>
            {priceCard.map(item => <S.Td maxWidth={/Member/.test(item.title)}><DefaultButtonDark title={item.title} button={item.button} /></S.Td>)}
          </S.Tr>
        </tbody>
      </S.Table>
      <S.Footnotes>
        {footnotes.map(note => <S.Footnote>{note}</S.Footnote>)}
      </S.Footnotes>
    </S.TableWrapper>
  )
};

export default PriceCard;
